<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col">
        <div class="row mb-3 pt-3 text-center">
          <div class="col-md-3"><h5>Edit Profile</h5></div>
        </div>

        <div class="card mt-2">
          <div class="card-body p-0">
            <div v-if="loading" class="text-center py-3">   
      <div class="py-2"><i class="fas fa-spinner fa-spin fa-3x"></i></div>
      </div>
            <div v-else class="col">
              <div class="p-2">

                <div class="row mt-2">
                  <div class="col-md-6">
                    <label class="form-label" for="fullname">First Name</label>
                    <input
                      type="text"
                      class="form-control2 dt-full-name"
                      v-model.trim="$v.name.$model"
                      tabindex="1"
                      :class="status($v.name)" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label" for="dealer-name">Last Name</label>
                    <div><input type="text" class="form-control2 dt-salary" v-model.trim="$v.surname.$model" :class="status($v.surname)" tabindex="2"/></div>
                  </div>
</div>

                  <div class="row mt-2">
                  <div class="col-md-6">
                    <label class="form-label" for="dealer-name">Email</label>
                    <div><input type="text" class="form-control2 dt-salary" v-model.trim="$v.email.$model" :class="status($v.email)" tabindex="2"/></div>
                  </div>
                  
                  </div>

                </div>

                <div
                  class="alert alert-danger p-1 mt-3 text-center"
                  role="alert"
                  v-if="submitStatus === 'ERROR'">
                  Please correct the sections marked in red
                </div>

<div class="col px-2">
                  <button v-if="submitting" class="btn btn-success col mt-3 mb-3">
  <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i>Saving profile ...</button>
<button v-else type="submit" @click="saveForm()" class="btn btn-danger col mt-3 mb-3">
                  Save Profile
                </button>
</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
 
</template>

<script>
import "vue-select/dist/vue-select.css";
import {
  required,
  minLength,
  numeric,
  email,
  maxLength,
} from "vuelidate/lib/validators";

export default {
  props: ['type'],
  data() {
    return {
      user: {},
      name: "",
      surname: "",
      email: "",
      submitting: false,
      submitted: false,
      submitStatus: null,
      loading: false,
    };
  },

  validations: {
    name: { required, minLength: minLength(1) },
    surname: { required, minLength: minLength(1) },
    email: { required, email },
  },

  created() {
    this.getUserInfo();
  },

  methods: {

    getUserInfo() {

      this.loading = true;

      axios
        .post("/profile/getinfo")
        .then((response) => {
          this.user = response.data;
          this.name = this.user.name,
          this.surname = this.user.surname,
          this.email = this.user.email,
          this.loading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.loading = false;
        });
    },

    status(validation) {
      return {
        error: validation.$error,
        dirty: validation.$dirty,
      };
    },

    saveForm() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {

        this.submitting = true;

        this.submitStatus = "PENDING";
        setTimeout(() => {
          this.submitStatus = "OK";
        }, 500);

        this.saveProfile();

      }

    },

    saveProfile() {
      axios
        .post('/profile/save', {

          name: this.name,
          surname: this.surname,
          email: this.email,
          type: this.type,
        })
        .then((response) => {
          
          if (response.data.success) {
            window.open('/profile', '_self');
          } else {
            this.sweetfire(response.data.message);
            this.submitting = false;
          }

          });
      },

      sweetfire(text) {

            Swal.fire({
            title: text,
            showConfirmButton: false,
            showDenyButton: false,
            showCancelButton: true,
            focusConfirm: false,
            cancelButtonText: 'Ok',
            customClass: {
                    title: "popup-title",
                  },
          })

          },

  },
};
</script> 

<style scoped>

</style>